import { RouterLink } from '../../generic/Link';

import styles from './ForgotPasswordLink.module.less';

/**
 * "Forgot password?" link to the password-reset page.
 */
const ForgotPasswordLink = () => (
  <div className={styles.forgotPassword}>
    <RouterLink to="/auth/password-reset">Forgot password?</RouterLink>
  </div>
);

export default ForgotPasswordLink;
